import axios from 'axios';

export const getComissoesComites = () => axios.get('/comissao-comite');
